import BarChartIcon from "@src/assets/icons/BarChartIcon";
import Colors from "@constants/Colors";
import { StyledButtonBox, StyledButton } from "./styles";

interface ViewAllButtonProps {
  onclick: () => void;
  disabled: boolean;
}

const ViewAllButton = ({ onclick, disabled }: ViewAllButtonProps) => {
  return (
    <StyledButtonBox>
      <StyledButton onClick={onclick} disabled={disabled}>
        <BarChartIcon
          strokeColor={disabled ? Colors.primarygray_300 : Colors.primary}
        />
        View All Data
      </StyledButton>
    </StyledButtonBox>
  );
};

export default ViewAllButton;
